module.exports = __webpack_public_path__ + "static/media/full_story.9ec5cef1.png";